import { ArrowRight, CalendarHeart } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function Hero() {
  const { t } = useLang();
  return (
    <section id="top" className="relative overflow-hidden bg-forest-900 text-parchment grain">
      <img src="/images/hero-diya.jpg" alt="Brass diya glowing" className="absolute inset-0 w-full h-full object-cover opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-r from-forest-900 via-forest-900/80 to-transparent" />
      <div className="relative max-w-6xl mx-auto px-5 pt-20 pb-24 sm:pt-28 sm:pb-32">
        <p className="eyebrow !text-brass-300 rise" data-testid="hero-eyebrow">{t("hero.eyebrow")}</p>
        <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] max-w-2xl rise" style={{ animationDelay: "0.1s" }} data-testid="hero-title">
          {t("hero.t1")} <em className="text-brass-300">{t("hero.em")}</em> {t("hero.t2")}
        </h1>
        <p className="mt-6 text-base sm:text-lg text-parchment/80 max-w-xl leading-relaxed rise" style={{ animationDelay: "0.2s" }}>
          {t("hero.sub")}
        </p>
        <div className="mt-9 flex flex-col sm:flex-row gap-3 rise" style={{ animationDelay: "0.3s" }}>
          <a href="#booking" className="inline-flex items-center justify-center gap-2 bg-brass-500 hover:bg-brass-300 text-forest-900 font-semibold px-7 py-3.5 rounded-full transition-colors" data-testid="hero-book-button">
            <CalendarHeart className="w-4 h-4" /> {t("hero.book")}
          </a>
          <a href="#courses" className="inline-flex items-center justify-center gap-2 border border-parchment/40 hover:bg-parchment/10 px-7 py-3.5 rounded-full transition-colors" data-testid="hero-courses-button">
            {t("hero.courses")} <ArrowRight className="w-4 h-4" />
          </a>
        </div>
        <div className="mt-14 flex flex-wrap gap-x-6 gap-y-2 text-sm text-parchment/70 rise" style={{ animationDelay: "0.4s" }}>
          {t("hero.mods").map((m) => (
            <span key={m} className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-brass-500" />{m}</span>
          ))}
        </div>
      </div>
    </section>
  );
}
